




















































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import CensusUploadRules from "@/employer/components/profile/CensusUploadRules.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    CensusUploadRules
  }
})
export default class CensusUploadModal extends Vue {
  themeStore = useThemeStore();

  get fileSubmitCutoffHour () {
    const now = moment();
    let utc17 = moment.utc([now.year(), now.month(), now.day(), 17]);

    if (now.isAfter(utc17)) {
      // go to tomorrow
      utc17 = utc17.add(1, "days");
    }

    return utc17.isDST() ? "1" : "12";
  }
}
